<template>
    <div  class="mx-md-5 my-4">
        <div class="container-fluid w-100">
            <div class="notification-list mb-2" v-can="'Créer une alerte'">
                <button class="btn btn-primary shadow btnl" @click="addAlerte">
                    <i class="fas fa-solid fa-plus"></i>Nouvelle alerte
                </button><br>
            </div>
            <div class="pt-5 d-md-flex w-100 flex-wrap">
                <div class="mr-md-auto mt-2">
                    <h2 class="default fwb">Liste des alertes</h2><br>
                </div>
                <div class="ml-md-auto">
                    <ul class="list-none p-0 d-md-flex align-items-end gap-2">
                        <div class="d-flex align-items-center justify-content-between gap-1">
                           <!--  <li class=""><button class="btn p-0 text-primary fwb">Tous</button></li>
                            <li class=""><button class="btn p-0 text-primary fwb">Non lus</button></li> -->
                            <li class="">
                                <select class="form-select select-height mt-2 mt-md-0" v-model="statut_id" aria-label="Default select example" @change="changeStatut($event)">
                                    <option value="">Tout</option>
                                    <option v-for="(statut, index) in statuts" :key="'statut'+index" :value="statut.id">{{ statut.valeur }}</option>
                                </select>
                            </li>
                        </div>
                        <li class="mt-2 mt-md-0"><input type="text" v-model="search" @keyup="searchAlerte($event)" class="form-control" placeholder="rechercher une plainte ou un patient"></li>
                    </ul>
                </div>
            </div>
            <div class="">
                <div class="bg-transparent d-none d-md-block">
                    <div class="rounded taille mb--3 align-items-center">
                        <ul class="list-none px-2 py-2 row-lg table-header gap-2 justify-content-between d-flex align-items-center">
                            <!-- <li class="col-lg ml-2"><input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" /></li> -->
                            <li class="col-lg nom" v-if="!hasPatientRole">Patients</li>
                            <li class="col-lg nom">Plainte</li>
                            <li class="col-lg gravite ml-4 cursor">Urgence <i class="fa fa-info-circle transparentGrey" id="popover-target-2"></i>
                                <b-popover target="popover-target-2" triggers="hover" placement="bottomright" class="w-100" bg-variant="dark">
                                    <div class="">
                                        <h6 class="text-white">État leger (1-2)</h6>
                                        <h6 class="text-white">État modérer (3)</h6>
                                        <h6 class="text-white">État sévère (4)</h6>
                                        <h6 class="text-white">État le plus grave (5)</h6>
                                    </div>
                                </b-popover>
                            </li>
                            <li class="col-lg d-none d-lg-block">Date</li>
                            <li class="col-lg d-none d-lg-block">Status</li>
                            <li class="col-lg d-none d-lg-block">Action</li>
                        </ul>
                    </div>
                    <div class="row justify-content-center my-4 pr-2" role="status" v-if="!alertes.data">
                        <div class="loading"></div>
                    </div>
                    <div class="rounded bg-white mb-1 align-items-center" v-for="item in alertes.data" :key="item.id">
                        <ul class="list-none d-flex row-lg default fwn px-2 py-3 mb-2 gap-2 justify-content-between align-items-center" id="modalTC">
                            <!--  card-active <li class="col-lg "><input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" /></li> -->
                            <li class="col-lg d-flex align-items-center gap-1" v-if="!hasPatientRole">
                                <!-- <i class="fas fa-circle text-primary text-i"></i> -->
                                <span class="m-0 fwb" v-if="item.patient && !hasPatientRole">{{truncate(item.patient.name, 15)}}</span>   
                            </li>
                            <li class="col-lg d-md-flex align-items-center gap-1 cursor">
                                <span class="m-0 fwb px-0" v-if="item.patient" :id="`popover-target-${item.id}`">{{truncate(item.plainte, 18) }}</span> 
                                <span v-if="item.audio" class="cursor"  @click="SoundVoice(item.audio)"><i class="fa fa-play-circle fa-1x fs2" aria-hidden="true"></i></span>
                                <b-popover :target="`popover-target-${item.id}`" triggers="hover" placement="bottom">
                                    <div class="">
                                        <h6 class="text-white">{{item.plainte}}</h6>
                                    </div>
                                </b-popover>
                            </li>
                            <li class="col-lg d-md-flex align-items-center gap-1">
                                <b-col md="12"
                                    class="">
                                    <span class="py-0 border-0 cursor" :id="`popover-2-${item.id}`" variant="outline-dark">Niveau {{item.niveau_urgence.valeur}}</span>
                                    <b-popover :target="`popover-2-${item.id}`" placement="bottom" triggers="hover">
                                        <div class="">
                                            <h6 class="text-white">{{item.niveau_urgence.description}}</h6>
                                        </div>
                                    </b-popover>
                                </b-col>
                            </li>

                            <li class="col-lg d-none d-flex align-items-center">{{formattedDateTime(item.created_at)}}</li>
                            <li class="col-lg d-none d-flex align-items-center">
                                <span>
                                    <b-badge :variant="changeColor(item.statut.id)" class="m-0 default fwb text-end fs-6 cursor" :id="`popover-4-${item.id}`"><i class="fa fa-user-doctor mx-1" v-if="item.statut.valeur == 'En cours'"></i>{{ item.statut.valeur }}</b-badge>
                                    <b-popover :target="`popover-4-${item.id}`" triggers="hover" placement="bottom">
                                        <div class="">
                                            <h6 class="text-white">{{item.statut.description}}</h6>
                                        </div>
                                    </b-popover>
                                </span>
                            </li>
                            <li class="col-lg d-flex align-items-center">
                                <span @click="openModalShow(item.uuid)" v-can="'Afficher une alerte'" size="sm" class="border-right text-primary cursor border-5 pr-2">
                                    <!-- <svg viewBox="64 64 896 896" focusable="false" data-icon="edit" width="1.2em" height="1.2em" fill="currentColor" aria-hidden="true"><path d="M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z"></path></svg> -->
                                    <i class="fa fa-eye mr-1"></i>voir
                                </span>
                                <span class="cursor" size="sm" v-can="'Supprimer une alerte'" v-if="hasAssistante || ((hasSouscripteurRole || hasPatientRole || hasMedecinControleRole) &&  item.statut.id == 1) ">
                                    <i @click="ModalAlerteDelete(item)" class="fa fa-trash colorGrey px-2" aria-hidden="true"></i>
                                    <!-- <i @click="getAlerte(item)" class="fas fa-edit"></i> -->
                                </span>
                                <span class="cursor" size="sm" v-if="(hasSouscripteurRole || hasPatientRole || hasMedecinControleRole || hasPraticienRole) &&  item.statut.id != 1">
                                    <i class="fa fa-trash transparentTextGrey px-2" aria-hidden="true"></i>
                                    <!-- <i @click="getAlerte(item)" class="fas fa-edit"></i> -->
                                </span>
                            </li>
                        </ul>
                        <b-modal :id="'modal-'+item.uuid" title="Information sur l'alerte" size="lg" :hide-footer="true"  :header-bg-variant="headerBgVariant" :header-text-variant="headerTextVariant">
                                <template v-slot:modal-header>
                                        <h5 class="modal-title text-white">
                                            <b>Informations de l'alerte</b>
                                        </h5>
                                        <i class="fa fa-times text-white" aria-hidden="true" @click="$bvModal.hide('modal-'+item.uuid)"></i>
                                    </template> 
                                    <NotificationInfo :uuid="item.uuid" :alerte="item" :moreDetails="moreDetails" @clickClose="$bvModal.hide('modal-'+item.uuid)" @clickDelete="ModalAlerteDelete(item)"/>
                            </b-modal>
                        <b-collapse :id="'collapse'+item.id" class="mb-2">
                            <b-card class="border-0">
                                <li class="list-none mb-3 rounded card-text urgence-3 px-3 py-2 fwb">Niveau d'urgence : {{item.niveau_urgence.valeur}}</li>
                                <li class="list-none mb-2 card-text default fwb"><span class="font-weight-bold">Souscripteur</span> : {{item.creator.name}}</li>
                                <li class="list-none mb-2 card-text default fwb"><span class="font-weight-bold">Plainte</span> : {{item.plainte}}</li>
                                <li class="list-none mb-2 default"><span class="font-weight-bold">Date émission</span> : {{formattedDateTime(item.created_at)}}</li>

                                <!-- <li class="list-none mb-2 default cursor-pointer" @click="goAlerte()"> <p class="text-primary">Voir plus de details</p></li> -->
                                <div class="d-flex gap-1 d-lg-none gap-1 text-secondary m-0 float-end">
                                    <li class="alert-icon del list-none"><i class="cursor-pointer fas fa-trash"></i></li>
                                    <li class="alert-icon up list-none"><i class="fas fa-edit"></i></li>
                                </div>
                            </b-card>
                        </b-collapse>
                        <ModalAlerte :modal_id="'modal'+item.uuid" :alerte="item"/>
                    </div>
                    
                    <ModalAlerte modal_id="modal" :alerte="{}"  @clickClose="$bvModal.hide('modal')"/>
                    <ModalDeleteAlerte id="delete-modal" :item="item"/>
                </div>

                
                <!-- Mobile version -->
                <div class="shadow d-block d-md-none m-auto pt-2">
                    <div class="row justify-content-center my-4 pr-2" role="status" v-if="!alertes.data">
                        <div class="loading"></div>
                    </div>
                    <div  v-for="item in alertes.data" :key="item.id" class="list-group list-group-flush">
                        <div class="d-flex flex-row justify-content-between w-100 p-1 my-1 list-group-item" v-b-toggle="'collapse'+item.id">
                            <div class="" >
                                <span for="" class="my-2 text-h5 fw-semibold" v-if="!hasPatientRole">Nom patient:</span>
                                <span for="" class="my-2 text-h5 fw-semibold" v-if="hasPatientRole">Ma plainte:</span>
                                <h6 class=" colorGrey text-uppercase pt-1 text-h5" v-if="item.patient && hasPatientRole">{{truncate(item.plainte, 25) }}</h6>
                                <h6 class=" colorGrey text-uppercase pt-1 text-h5" v-if="!hasPatientRole">{{item.patient.name}}</h6>
                            </div>
                            <div class="when-closed">
                                <i class="fa fa-angle-down px-2 text-dark text-h5"></i>
                            </div>
                            <div class="when-open">
                                <i class="fa fa-angle-right px-2 text-dark text-h5 "></i>
                            </div>
                        </div>          
                        <b-collapse :id="'collapse'+item.id" class="mb-2 w-100">
                                <div class="container-fluid w-100">
                                        <div class="row py-1 list-none w-100">
                                            <li class="list-none mb-3 rounded card-text urgence-3 px-1 py-2 fwb">Niveau d'urgence : {{item.niveau_urgence.id}} <p class="justify-content-center">{{item.niveau_urgence.description}}</p>
                                            <b-popover :target="`popover-1-${item.id}`" title="Description" triggers="hover focus" :content="item.niveau_urgence.description"></b-popover></li>
                                            <li class="list-none mb-2 card-text default fwb"><span class="font-weight-bold">Souscripteur</span> : {{item.creator.name}}</li>
                                            <li class="list-none mb-2 card-text default fwb"><span class="font-weight-bold">Plainte</span> : {{item.plainte}}</li>
                                            <li class="list-none mb-2 default"><span class="font-weight-bold">Date émission</span> : {{formattedDateTime(item.created_at)}}</li>

                                            <!-- <div class="d-flex justify-content-between d-lg-none mx-0 mb-1 mt-2 w-100">
                                                <li class="alert-icon del list-none text-danger"><i class="cursor-pointer fas fa-trash"></i></li>
                                                <li class="alert-icon up list-none text-dark"><i class="fas fa-edit"></i></li>
                                            </div> -->
                                        </div>
                                        <div class="d-flex mb-2 justify-content-center mt-2 w-100" v-can="'Supprimer une alerte'" v-if="hasSouscripteurRole &&  item.statut.id == 1 || hasAssistante || hasPatientRole &&  item.statut.id == 1 || hasMedecinControleRole &&  item.statut.id == 1 ">
                                            <button  @click="ModalAlerteDelete(item)" size="sm" class="btn btn-outline-danger px-2 fw-bold text-h5 w-100">
                                                <i class="fa fa-trash px-1"></i><span class="px-1">Supprimer</span>
                                            </button>
                                        </div>
                                        <div class="d-flex mb-2 justify-content-center mt-2 w-100" v-can="'Afficher une alerte'">
                                            <button  @click="openModalShow(item.uuid)" size="sm" class="btn btn-primary px-2 fw-bold text-h5 w-100">
                                                <i class="fa fa-eye px-1"></i><span class="px-1">Voir plus de details</span>
                                            </button>
                                        </div>
                                </div>
                        </b-collapse>
                    </div>
                </div> 
            </div>

            <div>
                <div class="mt-3" v-if="alertes.data">
                    <nav aria-label="Page navigation example">
                        <ul class="pagination justify-content-end" id="pagination-demo">
                            <li :class="`page-item ${alertes.current_page == alertes.from ? 'disabled' : ''}`"><a class="page-link" href="#" @click="previous(alertes.current_page)" tabindex="-1" aria-disabled="true"> <span aria-hidden="true">&laquo;</span>
                                <span class="sr-only">Previous</span></a>
                            </li>
                            <li :class="`page-item ${alertes.current_page == n ? 'active' : ''}`" v-for="n in pages" @click="changePage(n)"><a class="page-link" href="#">{{ n }}</a></li>
                            <li class="page-item">
                                <li :class="`page-item ${alertes.current_page == alertes.last_page ? 'disabled' : ''}`"><a class="page-link" href="#" @click="next(alertes.current_page)" tabindex="-1" aria-disabled="true"> <span aria-hidden="true">&raquo;</span>
                                    <span class="sr-only">Next</span></a>
                                </li>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
        <div>
          <AlertLayout />
        </div>
    </div>
</template>
<script>
import moment from "moment";
import ModalAlerte from "./ModalAlerte.vue"
import Swal from 'sweetalert2';
import Vue from 'vue';
import {mapGetters, mapState} from "vuex";
import Multiselect from 'vue-multiselect'
import AppConfig from "../../constants/AppConfig";
import BaseSelected from '@/components/BaseSelected.vue'
import Autocomplete from '@trevoreyre/autocomplete-vue'
import AlertLayout from '../../layout/AlertLayout.vue';
import NotificationInfo from "../../layout/NotificationInfo.vue";
import ModalDeleteAlerte from "./ModalDeleteAlerte.vue"
export default {
    name: "Alertes",

    components: {
        BaseSelected,
        Autocomplete,
        NotificationInfo,
        Multiselect,
        AlertLayout,
        ModalAlerte,
        ModalDeleteAlerte
    },
    computed: {
        ...mapGetters(["errors", 'hasPatientRole', 'hasPraticienRole','hasMedecinControleRole', 'hasAdminRole', 'hasSouscripteurRole', 'hasGestionnaireRole', 'hasAssistante', 'alertes', 'statuts' ,'urgences']),
        mPatients: function() {
            let pArray = [];

            _.forEach(this.liste_patient.data, function(patient) {
                if (typeof patient == 'object'){
                    if(patient.user != null){
                        let name = patient.user.name ;
                        pArray.push({name: name, id: patient.user_id });

                        }
                    }
                }
            );
            return pArray;
        },
        pages() {
                let numShown = 6;   // This sets the number of page tabs
                numShown = Math.min(numShown, this.alertes.last_page);
                let first = this.alertes.current_page - Math.floor(numShown / 2);
                first = Math.max(first, 1);
                first = Math.min(first, this.alertes.last_page - numShown + 1);
                return [...Array(numShown)].map((k,i) => i + first);
            },
        pUrgencesAlarm: function(){
            let mArray = [];
            _.forEach(this.urgences, function(urgence) {
                // urgence =  urgence.description;
                let text =  urgence.id;
                let value =  urgence.valeur;
                mArray.push({id: text, nom: value });
            });
            return mArray;
        },

        pUrgences: function(){
            let mArray = [];
            _.forEach(this.urgences, function(urgence) {
                // urgence =  urgence.description;
                let text =  urgence.id;
                let value =  urgence.valeur;
                mArray.push({text: text, value: value });
            });
            return mArray;
        },
    },

    data() {
        return {
            headerBgVariant: 'dark',
            headerTextVariant: 'light',
            bodyBgVariant: 'light',
            bodyTextVariant: 'dark',
            load: true,
            isLoading: false,
            liste_patient: [],
            moreDetails: true,
            loading: false,
            alerte: {},
            item: {},
            patientState: null,
            niveaUrgenceState: null,
            plainteState: null,
            submittedNames: [],
            alertForm: false,
            settings: false,
            singleAlert:{},
            Home: false,
            mobileView: true,
            uuid: this.$route.query.uuid,
            search: "",
            statut_id: ""
        }
    },

    methods: {
        changeColor(item) {
            if (item === 1) {
                return 'warning'
            }
            else if (item === 2) {
                return 'success';
            }
            else if (item === 3) {
                return 'primary'
            }
            else if (item === 4) {
                return 'danger'
            }
		},
        addAlerte(){
            this.$bvModal.show('modal');
        },
        getAlerte(item){
            this.alerte = item;
            this.$bvModal.show('modal'+item.uuid);
        },
        ModalAlerteDelete(item){
            this.item = item;
            this.$bvModal.show("delete-modal");
        },
        openModalShow(uuid){
            this.uuid = uuid;
            this.$bvModal.show("modal-"+this.uuid);
        },
        SoundVoice(audio){
            let audioFile = new Audio(audio);
            audioFile.play();
        },
        searchAlerte(event){
            if(event.target.value.length > 2){
                this.getAlertes(1, event.target.value, 5, this.statut_id);
            }else if(event.target.value == ""){
                this.getAlertes(1, "", 5, this.statut_id);
            }
        },
        changeStatut(event){
            this.getAlertes(1, "", 5, event.target.value);
        },
        getSearchPatient(patient){
            this.loading = true;
            fetch(AppConfig.apiUrl+`/v2/patients?search=${patient}`, {headers: {'Authorization': "Bearer " + localStorage.getItem('ms-token')}})
                .then(res => res.json())
            .then(res => {
                this.loading = false;
                this.liste_patient = res
            }).catch(error => {
                console.log('error ', error);
            })
        },
        previous(page){
            page--
            this.getAlertes(page, "", 5, this.statut_id);
        },
        next(page){
            page++
            this.getAlertes(page, "", 5, this.statut_id);
        },
        changePage(page){
            this.getAlertes(page, "", 5, this.statut_id);
        },
        truncate(str, n){
            return (str.length > n) ? str.slice(0, n-1) + '...' : str;
        },
        formattedDateTime(date) {
            if (moment(date).isValid() && date != null) {
                return moment(date).format("DD-MM-YYYY à HH:mm");
            } else {
                return date;
            }
        },
        getAlertes(page = 1, search = "", size = 5, statut_id = "") {
            let args = {
                page: page,
                search: search,
                size: size,
                statut_id: statut_id
            };

            this.$store.dispatch('getAlertes', { args : args });
        },

        getNiveauUrgence() {
            let args = {
                offset: this.offset,
                limit: this.limit,
                // id:(JSON.parse(localStorage.getItem('user')))['id']
            };

            this.$store.dispatch('getNiveauUrgence', { args : args });
        },
        goAlerte(){
            router.push('/alertes')
            // router.push({ name: '/alertes', params: { uuid: 'item.uuid' } })  
        },
        infoModal(cmd) {
          this.settings=true,  
            this.$bvModal.show('modalInfo');
            this.singleAlert=cmd
        },

        handleView() {
            this.mobileView = window.innerWidth <= 990;
        },

    },
    mounted() {
        if(this.uuid != undefined){
            this.openModalShow(this.uuid);
        }
        this.getAlertes();
        let args = {
                page: 1,
                search: "",
                size: 4,
            };
        this.$store.dispatch('listStatuts', { args : args });
        this.getNiveauUrgence();
        let user = JSON.parse(localStorage.getItem('user'));
        this.$gtag.set({
            'user_id': user.id,
            'role': localStorage.getItem('role'),
            'email': user.email
        })
        this.$gtag.event("Listing des alertes", {
            'event_category': "Alertes",
            'event_label': "Listing des alertes"
        })
    },
}
</script>
<style lang="scss">
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>